import { User } from "../../models/interfaces";


export interface AuthState {
    status: 'checking' | 'authenticated' | 'not-authenticated';
    token: string | null;
    errorMessage: string;
    successMessage: string;
    user: User | null;
}

type AuthAction = 
    | { type: 'signUp', payload: { token: string, user: User } }
    | { type: 'addError', payload: string }
    | { type: 'addMessage', payload: string }
    | { type: 'removeError' }
    | { type: 'notAuthenticated' }
    | { type: 'logout' }
    | { type: 'isLoging' }


export const authReducer = ( state: AuthState, action: AuthAction ): AuthState => {

    switch (action.type) {
        case 'addError':
            return {
                ...state,
                user: null,
                status: 'not-authenticated',
                token: null,
                errorMessage: action.payload
            }
        case 'addMessage':
            return {
                ...state,
                user: null,
                status: 'not-authenticated',
                token: null,
                successMessage: action.payload
            }
        case 'removeError':
            return {
                ...state,
                errorMessage: '',
                successMessage: ''
            };
        case 'isLoging':
                return {
                    ...state,
                    status: 'checking',
                    errorMessage: '',
                successMessage: ''
                };
        case 'signUp':
            return {
                ...state,
                errorMessage: '',
                status: 'authenticated',
                token: action.payload.token,
                user: action.payload.user
            }

        case 'logout':
        case 'notAuthenticated':
            return {
                ...state,
                status: 'not-authenticated',
                token: null,
                user: null
            }

        default:
            return state;
    }


}

